import { ParticipantTile, useLocalParticipant, useTracks } from "@livekit/components-react";
import { FocusedLayout } from "../focused-layout/focus-layout";
import { Layout } from "../conference-layout/layout";
import { Track } from "livekit-client";
import { useMemo, useState } from "react";
import s from './video-conference.module.scss'
// import { NetworkStats } from "./network-stats";

export function VideoConference({isFocused, focusClassName, carouselClassName}) {
	const { localParticipant, lastMicrophoneError, lastCameraError } = useLocalParticipant();
	const [mediaRetryError, setMediaRetryError] = useState("");
	const tracks = useTracks([
		{ source: Track.Source.Camera, withPlaceholder: true },
	]);
	const screenShareTracks = useTracks([
		{ source: Track.Source.ScreenShare },
		{ source: Track.Source.ScreenShareAudio },
	]);
	const screenShareTrack = screenShareTracks.find((t) => t.source === Track.Source.ScreenShare);
	const hasParticipants = tracks.length > 0;
	const hasVideoContent = hasParticipants || !!screenShareTrack;

	const mediaPermissionError = useMemo(() => {
		const candidates = [lastMicrophoneError, lastCameraError, mediaRetryError].filter(Boolean);
		const deniedError = candidates.find((item) => {
			const message = (item?.message || item || "").toString().toLowerCase();
			return (
				message.includes("permission") ||
				message.includes("notallowed") ||
				message.includes("denied") ||
				message.includes("разреш")
			);
		});

		if (!deniedError) {
			return "";
		}

		return "Доступ к камере или микрофону запрещен. Разрешите доступ в настройках браузера и повторите подключение.";
	}, [lastMicrophoneError, lastCameraError, mediaRetryError]);

	const retryMediaAccess = async () => {
		try {
			setMediaRetryError("");
			await Promise.allSettled([
				localParticipant?.setMicrophoneEnabled?.(true),
				localParticipant?.setCameraEnabled?.(true),
			]);
		} catch (error) {
			setMediaRetryError(error?.message || "Не удалось повторно запросить доступ к устройствам.");
		}
	};

	const placeholders = (
		<div className={s.placeholders}>
			<div className={s.placeholderCard}>
				<div className={s.placeholderTitle}>Ваше видео</div>
				<div className={s.placeholderText}>Подключаем камеру и микрофон...</div>
			</div>
			<div className={s.placeholderCard}>
				<div className={s.placeholderTitle}>Участник</div>
				<div className={s.placeholderText}>Ожидаем подключение собеседника...</div>
			</div>
		</div>
	);

	if(isFocused){
		return (
			<>
				{mediaPermissionError ? (
					<div className={s.permissionError}>
						<span>{mediaPermissionError}</span>
						<button type="button" onClick={retryMediaAccess}>Запросить доступ снова</button>
					</div>
				) : null}
				{hasVideoContent ? (
					<FocusedLayout tracks={tracks} focusTrack={screenShareTrack} {...{focusClassName, carouselClassName}}/>
				) : (
					placeholders
				)}
			</>
		);		
	}

	return (
		<div className={s.layoutWrapper} >
      
			{mediaPermissionError ? (
				<div className={s.permissionError}>
					<span>{mediaPermissionError}</span>
					<button type="button" onClick={retryMediaAccess}>Запросить доступ снова</button>
				</div>
			) : null}
			{hasVideoContent ? (
				screenShareTrack ? (
					<FocusedLayout tracks={tracks} focusTrack={screenShareTrack}/>
				) : (
					<Layout tracks={tracks}>
						<ParticipantTile />
					</Layout>
				)
			) : (
				placeholders
			)}
			{/* {process.env.REACT_APP_DEV ? <NetworkStats /> : ''} */}
		</div>
	);
}
